export default __webpack_public_path__ + "static/media/107.57d34e7d.gif";